import type { IconSvgObject } from './types';

const LockComputerIcon: IconSvgObject = [
  ["path", { d: "M16.5 5.5H15V11H22V5.5H20.5M16.5 5.5V4C16.5 2.89543 17.3954 2 18.5 2C19.6046 2 20.5 2.89543 20.5 4V5.5M16.5 5.5H20.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 2L4 2C2.89543 2 2 2.89543 2 4V15.9997C2 17.1043 2.89543 17.9997 4 17.9997H20C21.1046 17.9997 22 17.1043 22 15.9997V14.4997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 15H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 18L12.0033 21.9953M12.0033 21.9953L16 22M12.0033 21.9953L8 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default LockComputerIcon;
